export const occupationOptions = [
  { occupationId: "service", occupation: "Service" },
  { occupationId: "self-employed", occupation: "Self Employed" },
  { occupationId: "professional", occupation: "Professional" },
  { occupationId: "retired", occupation: "Retired" },
  { occupationId: "student", occupation: "Student" },
  { occupationId: "house-wife", occupation: "House Wife" },
];

export const maritialStatusOptions = [
  { maritalStatus: "SINGLE", maritalStatusId: "SINGLE" },
  { maritalStatus: "MARRIED", maritalStatusId: "MARRIED" },
  { maritalStatus: "WIDOWED", maritalStatusId: "WIDOW" },
];

export const genderOptions = [
  {
    value: "MALE",
    label: "Male",
  },
  {
    value: "FEMALE",
    label: "Female",
  },

  {
    value: "OTHERS",
    label: "Others",
  },
];
export const isPoliticallyExposedOptions = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];

export const isSmokerOptions = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
];
export const relationshipOptions = [
  {
    value: "SPOUSE",
    label: "Spouse",
  },
  {
    value: "MOTHER",
    label: "Mother",
  },
  {
    value: "FATHER",
    label: "Father",
  },
  {
    value: "SISTER",
    label: "Sister",
  },
  {
    value: "BROTHER",
    label: "Brother",
  },
  {
    value: "SON",
    label: "Son",
  },
  {
    value: "DAUGHTER",
    label: "Daughter",
  },
  {
    value: "GRANDSON",
    label: "Grandson",
  },
  {
    value: "GRANDDAUGHTER",
    label: "Granddaughter",
  },
  {
    value: "AUNT",
    label: "Aunt",
  },
  {
    value: "NIECE",
    label: "Niece",
  },
  {
    value: "NEPHEW",
    label: "Nephew",
  },
  {
    value: "GRANDFATHER",
    label: "Grandfather",
  },
  {
    value: "GRANDMOTHER",
    label: "Grandmother",
  },
];

export const industryTypeOptions = [
  {
    value: "limited",
    label: "Limited",
  },
  {
    value: "private-limited",
    label: "Private Limited",
  },

  {
    value: "trust",
    label: "Trust",
  },
  {
    value: "huf",
    label: "HUF",
  },
  {
    value: "partnership",
    label: "Partnership",
  },
  {
    value: "llp",
    label: "LLP",
  },
  {
    value: "proprietorship",
    label: "Proprietorship",
  },
];
